import PropTypes from 'prop-types';
import React from 'react';

const BankCard = '/icons/image-card-caixa.png';
import MessageText from '../MessageText';
import './MessageBankCaixa.style.scss';

export const MessageBankCaixa = (props) => {
  return (
    <>
      <MessageText
        id={props.question.id}
        text={props.question.text}
        html_id="message-bank-caixa"
        data-testid="message-bank-caixa"
        data-aut-test="message-bank-caixa"
      />
      <div className="message-line" id="image-bank-caixa">
        <div className="message-receive" id="msg-image-bank-caixa">
          <div className="message-div" data-aut-test="message-receive-text">
            <div className="bank-caixa">
              <img
                className="image-card-caixa"
                src={BankCard}
                alt="Cartão do banco caixa"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

MessageBankCaixa.propTypes = {
  question: PropTypes.object
};
